import React, { useCallback, useEffect, useState } from 'react'
import InputTextField from '../../../../../components/input/inputTextField';
import { SearchOutlined } from '@mui/icons-material';
import { ButtonBack, ButtonPrimary } from '../../../../../components/button/ButtonCustoms';
import TableCustom from '../../../../../components/table/tableCustom';
import { unsetLoading } from '../../../../../store/loading/loading.slice';
import TableRowCommon from '../../../../../components/table/TableRowCommon';
import OptionsButtonCustom from '../../../../../components/option-button/OptionsButtonCustom';
import { alertActive, swalError, swalSuccess } from '../../../../../components/alert/swal';
import { dateTimeToView } from '../../../../../utils/date.utils';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { OnlineCourseApi } from '../../../../../api/cms-online-course/online_course.api';
import ModalCustom from '../../../../../components/modal/ModalCustom';
import FilterSelect from '../../../../../components/select/filterSelect';
import { MenuItem } from '@mui/material';
import { handleTypingNumber } from '../../../../../utils/app.utils';
const defaultState = {
    id_online_course_study_topics: undefined,
    id_online_course_form: 0,
    online_course_config_form_point: 0,
    online_course_config_form_type: '',
}
const form_type: any[] = [{
    online_course_form_type_name: 'แบบสำรวจ', // i18n-ignore: translated at render site with t()
    online_course_form_type: 'SURVEY',
},
{
    online_course_form_type_name: 'แบบทดสอบก่อนเรียน', // i18n-ignore: translated at render site with t()
    online_course_form_type: 'QUIZ_BEFORE'
},
{
    online_course_form_type_name: 'แบบทดสอบหลังเรียน', // i18n-ignore: translated at render site with t()
    online_course_form_type: 'QUIZ_AFTER'
}
]
export default function CourseForm({ view }: any) {
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate: NavigateFunction = useNavigate();
    const [form, setForm] = useState<any>(defaultState)
    const [type, setType] = useState<string>("CREATE");
    const [open, setOpen] = useState<boolean>(false);
    const [data, setData] = useState<any[]>([]);
    const [formCourse, setFormCourse] = useState<any[]>([])
    const [listLesson, setListLesson] = useState<any[]>([]);
    const [listLessonTopic, setListLessonTopic] = useState<any[]>([]);
    const dispatch = useDispatch();
    const [search, setSearch] = useState<any>('')
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const listLessonTopicData = async (id_online_course_lesson: any) => {

        try {
            const res = await OnlineCourseApi.listLessonTopic(id, id_online_course_lesson);
            const data = res.data
            if (data?.status < 300) {
                setListLessonTopic(data?.data);

            } else {
            }
        } catch (error) {
        }
    }

    const getConfigFormById = async (id_config_form: any) => {
        const res = await OnlineCourseApi.getconfigFormById(id, id_config_form);
        const data = res.data
        if (res.status < 300) {
            setForm(data?.data)
            listLessonTopicData(data?.data?.id_online_course_lesson)
        }
    }
    const headCells = [
        {
            id: "#",
            width: '100px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("ลำดับ")
        },
        {
            id: "leave_type_name",
            width: '280px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("ชื่อ"),
        },
        {
            id: "center",
            disablePadding: false,
            width: '200px',
            sortable: false,
            align: "center",
            label: t("ประเภท"),
        },

        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("ภายใต้หัวข้อการเรียน"),
        },
        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("คะแนนที่ผ่านเกณฑ์"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("ผู้ที่สร้าง/ปรับปรุงล่าสุด"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("วันที่สร้าง/ปรับปรุงล่าสุด"),
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '150px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const {
            id_online_course_config_form,
            online_course_form_name,
            online_course_config_form_type,
            online_course_study_topics_name,
            online_course_config_form_point,
            modifier_name,
            modified_date } =
            objData;

        const objRenderData = {
            key: id_online_course_config_form,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: no || "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: online_course_form_name,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        t(form_type?.find((item: any) => item?.online_course_form_type === online_course_config_form_type)?.online_course_form_type_name || '-')
                    ),
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        online_course_study_topics_name || '-'
                    ),
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        online_course_config_form_point || '-'
                    ),
                },

                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: modifier_name,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView
                            enableEdit={!view}
                            enableDelete={!view}
                            onViewClick={() => {
                                setOpen(true)
                                setType('VIEW')
                                getConfigFormById(id_online_course_config_form)
                            }}

                            onEditClick={() => {
                                setOpen(true)
                                setType('EDIT')
                                getConfigFormById(id_online_course_config_form)

                            }}
                            onDeleteClick={() => {
                                alertActive(t("ยืนยันที่จะลบ หรือไม่?"), '', t("ยืนยัน"), t("ยกเลิก"), () => {
                                    handleDelete(id_online_course_config_form)
                                })
                            }} />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };
    const loadData = useCallback(async () => {
        // dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, keyword: search };

            const res = await OnlineCourseApi.getconfigForm(condition, id);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit, search]);

    useEffect(() => {
        loadData();
    }, [loadData]);
    const handleClose = async () => {
        setOpen(false)
        setForm(defaultState)
    }
    const listLessonData = async () => {

        try {
            const res = await OnlineCourseApi.listLesson(id);
            const data = res.data
            if (data?.status < 300) {
                setListLesson(data?.data);

            } else {
            }
        } catch (error) {
        }
    }

    const getForm = async () => {
        let condition: any = {
            page: 1,
            pageLimit: 100
        };
        if (search) condition = { ...condition, keyword: search };

        const res = await OnlineCourseApi.getForm(condition);
        const data = res.data
        if (res.status < 300) {
            setFormCourse(data?.data.items)
        }
    }


    useEffect(() => {
        listLessonData()
        getForm()
    }, [])
    const handleCreate = async () => {
        const body = {
            id_online_course_study_topics: form?.id_online_course_study_topics,
            id_online_course_lesson: form?.id_online_course_lesson,
            id_online_course_form: form?.id_online_course_form,
            online_course_config_form_type: form?.online_course_config_form_type,
            online_course_config_form_point: form?.online_course_config_form_point,
        };
        if (type === 'EDIT') {
            await OnlineCourseApi.patchConfigForm(body, id, form.id_online_course_config_form).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('บันทึกแบบทดสอบ เรียบร้อยแล้ว'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t("เกิดข้อผิดพลาด"))
            })

        } else {
            await OnlineCourseApi.postConfigForm(body, id).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('เพิ่มแบบทดสอบ เรียบร้อยแล้ว'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t("เกิดข้อผิดพลาด"))
            })

        }
    }

    const handleDelete = async (id_form: any) => {
        await OnlineCourseApi.deleteConfigForm(id, id_form).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('ลบเรียบร้อย'))
                loadData()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t("เกิดข้อผิดพลาด"))
        })

    }
    return (
        <div>
            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
                    <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("ค้นหา")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            setSearch(e.target.value)
                        }}
                        value={search || ''}
                    />
                </article>

                <article
                    className="w-full col-span-12 md:col-span-4 lg:col-span-9 sm:col-span-12"
                    style={{
                        display: "flex",
                        justifyContent: "end",
                    }}
                >
                    {!view && <ButtonPrimary
                        onClick={() => {
                            // navigate(routeName.cms.OnlineCourseManagementCreate);
                            setOpen(true)
                            setType('CREATE')
                        }}
                        mode="add"
                        buttonName={t("เพิ่มแบบทดสอบ")}
                    />}
                </article>
            </div>
            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>
            <ModalCustom title={type === 'CREATE' ? t('เพิ่มแบบทดสอบ') : t('ข้อมูลแบบทดสอบ')} subTitle={t('กรุณาระบุรายละเอียด')} open={open} component={
                <div className='flex flex-col gap-4'>

                    <div>
                        <FilterSelect
                            value={form?.id_online_course_form || ""}
                            heading={t('แบบทดสอบ/แบบสำรวจ')}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={formCourse.map((item: any, index: number) => (
                                <MenuItem value={item.id_online_course_form} key={index + 1}>
                                    {item.online_course_form_name}
                                </MenuItem>
                            ))}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setForm({ ...form, id_online_course_form: e.target.value, online_course_config_form_type: formCourse?.find((item: any) => item?.id_online_course_form === e.target.value)?.online_course_form_type })
                            }}
                            disabled={false}
                        />
                    </div>
                    <div>
                        <FilterSelect
                            value={form?.online_course_config_form_type || ""}
                            heading={t('ประเภท')}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={form_type?.map((item: any, index: number) => (
                                <MenuItem value={item.online_course_form_type} key={index + 1}>
                                    {t(item.online_course_form_type_name)}
                                </MenuItem>
                            ))}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setForm({ ...form, online_course_config_form_type: e.target.value })
                            }}
                            disabled={false}
                        />
                    </div>
                    <div>
                        <InputTextField
                            heading={t("คะแนนที่ผ่านเกณฑ์")}
                            placeholder={t("ระบุ")}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // handleChangeValueSearch("leave_type_name", e.target.value);
                                setForm({ ...form, online_course_config_form_point: e.target.value })
                            }}
                            value={form.online_course_config_form_point || ''}
                            onkeypress={handleTypingNumber}
                        />
                    </div>
                    <div>
                        <FilterSelect
                            value={form?.id_online_course_lesson || ""}
                            heading={t('อยู่ภายใต้บทเรียน')}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={listLesson.map((item: any, index: number) => (
                                <MenuItem value={item.id_online_course_lesson} key={index + 1}>
                                    {item.online_course_lesson_name}
                                </MenuItem>
                            ))}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                listLessonTopicData(e.target.value)
                                setForm({ ...form, id_online_course_lesson: e.target.value })
                            }}
                            disabled={false}
                        />
                    </div>
                    <div>
                        <FilterSelect
                            value={form?.id_online_course_study_topics || ""}
                            heading={t('ภายใต้หัวข้อการเรียน')}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={listLessonTopic.map((item: any, index: number) => (
                                <MenuItem value={item.id_online_course_study_topics} key={index + 1}>
                                    {item.online_course_study_topics_name}
                                </MenuItem>
                            ))}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setForm({ ...form, id_online_course_study_topics: e.target.value })
                            }}
                            disabled={!form?.id_online_course_lesson}
                        />
                    </div>

                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                handleClose()
                            }}
                            buttonName={t("ยกเลิก")}
                        />
                        {type !== 'VIEW' && <ButtonPrimary
                            onClick={() => {
                                handleCreate()
                            }}
                            mode='add'
                            buttonName={t("ยืนยัน")}
                        />}
                    </div>
                </div>
            } />
        </div>
    )
}
